import { envConfig } from "../core/config";

export default () => envConfig === `prod`;
